/**
 * API response status
 * Must match constants in PHP class App\ViewModels\AjaxResponse
 */
export default new class {
  constructor() {
    this.STATUS_OK = "ok";
    this.STATUS_ERROR = "error";
    this.STATUS_VALIDATION_FAILED = "validation_failed";
    this.STATUS_ACCESS_DENIED = "access_denied";
    this.apiUrl = null;
    this.ajaxUrl = null;
  }
  getNoteApiUrl(ticketId, noteId) {
    return this.apiUrl + '/tickets/' + ticketId + '/notes/' + noteId;
  }
  getNoteUploadFileApiUrl(ticketId, noteId) {
    return this.getNoteApiUrl(ticketId, noteId) + '/upload-file';
  }
};
